import React, { Component } from 'react';
import ReactGA from 'react-ga';
import $ from 'jquery';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Blog from './Components/Blog';
import About from './Components/About';
import Downloads from './Components/Downloads';
import Resume from './Components/Resume';
import Contact from './Components/Contact';
import Testimonials from './Components/Testimonials';
import Portfolio from './Components/Portfolio';
import Events from './Components/Events';

class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      foo: 'bar',
      resumeData: {}
    };

   // ReactGA.initialize('UA-110570651-1');
   //ReactGA.pageview(window.location.pathname);

  }

  getResumeData(){
    $.ajax({
      url:'/resumeData.json',
      dataType:'json',
      cache: false,
      success: function(data){
        this.setState({resumeData: data});
      }.bind(this),
      error: function(xhr, status, err){
        console.log(err);
        alert(err);
      }
    });
  }
  
 getBlogPosts(){
      $.ajax({
      url:'https://public-api.wordpress.com/rest/v1/sites/thewebsmithsite.wordpress.com/posts?number=5',
      dataType:'json',
      cache: false,
      success: function(data){
         this.setState({blog: data});
      }.bind(this),
      error: function(xhr, status, err){
        console.log(err);
        alert(err);
      }
    });
 }
  

  getMarketplaceDownloads(){
    $.ajax({
      type: 'GET',
      url:'https://l9obg8c0vc.execute-api.eu-west-2.amazonaws.com/beta/downloads',
      "headers": {
        "x-api-key": "ZScu5ZqSb228VoUuze0UO7wAdhx0PgSC19JLYmwX",
        "cache-control": "no-cache",
      },
      dataType:'jsonp',
      //crossDomain: true,    
      success: function(data){
        this.setState({downloads: data});
      }.bind(this),
      error: function(xhr, status, err){
        console.log(err);
      }
    });
  }

  componentDidMount(){
    this.getResumeData();
    this.getBlogPosts();
  }

  render() {
    return (
      <div className="App">
        <Header data={this.state.resumeData.main}/>
        <About data={this.state.resumeData.main}/>
        <Blog data={this.state.blog}/>
        <Downloads data={this.state.resumeData.main}/>
        <Resume data={this.state.resumeData.resume}/>
        <Portfolio data={this.state.resumeData.portfolio}/>
        
        <Contact data={this.state.resumeData.main}/>
        <Footer data={this.state.resumeData.main}/>
       
        
        
      </div>
    );
  }
}

export default App;
